<div class="mt-3">
  <label for="roleSelector" class="form-label">View by Role</label>

  <ng-select
    [items]="roles"
    [multiple]="true"
    placeholder="Select or start typing..."
    [formControl]="formControl"
    [closeOnSelect]="false"
    [clearSearchOnAdd]="true"
    data-testid="role-selector"
  >
    <ng-template ng-option-tmp let-item="item">
      <input
        type="checkbox"
        [checked]="formControl.value.includes(item)"
      />
      {{ item }}
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="ng-value-label">{{ item }}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </div>
      }
    </ng-template>
  </ng-select>
</div>
